<template>
  <div class="product-variants mt-3 mb-2">
    <button
      v-if="variants.length > 1"
      v-for="variant in variants"
      :key="variant.id"
      class="product-variants__button"
      @click="selectVariant(variant.id)"
      :class="{ 'product-variants__button--active': activeVariantId === variant.id, 'product-variants__button--disabled': !variant.inStock }"
    >
      {{ variant.name }}
      <small v-if="!variant.inStock">Udsolgt</small>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    variants: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeVariantId: null
    };
  },
  created() {
    const initalValue = getSelectedVariantFromURL();
    if (initalValue) {
      this.selectVariant(initalValue);
    } else if(this.variants.length === 1) {
      this.selectVariant(this.variants[0].id);
    } else {
      this.selectVariant(null);
    }
  },
  methods: {
    selectVariant(id) {
      const _variant = this.variants.find(item => item.id === id);
      if (_variant) {
        this.activeVariantId = _variant.id;
        updateURLParams(_variant.id);
      }
      this.$emit("input", _variant);
    }
  }
};
function getSelectedVariantFromURL() {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("variant");;
}

function updateURLParams(variant) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set("variant", variant);
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}?${searchParams.toString()}`
  );
}
</script>
